module.exports = "dist/logo_police.png?15cdb5f417301f5f0fd0b3cdb062a295";